<template>
  <v-container fluid>
    <div>
      <v-row>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-menu ref="month_menu" v-model="month_menu" :close-on-content-click="false"
            :return-value.sync="queryForm.month" transition="scale-transition" min-width="auto" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="queryForm.month" label="月份" append-icon="mdi-calendar" readonly v-bind="attrs"
                v-on="on" dense outlined>
                <template v-slot:label>月份</template>
              </v-text-field>
            </template>
            <v-date-picker v-model="queryForm.month" type="month" no-title value="YYYY-mm" scrollable locale="zh-cn"
              @input="() => { $refs.month_menu.save(queryForm.month); month_menu = false; }"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="3" sm="6">
          <a-space>
            <v-btn @click="getdata()" color="primary" dark tile>
              <v-icon small>mdi-magnify</v-icon>查询
            </v-btn>
          </a-space>
        </v-col>
      </v-row>
    </div>
    <v-tabs v-model="tab" @change="changetab">
      <v-tab v-for="item in tablist" :key="item.value"> {{ item.label }} </v-tab>
    </v-tabs>
    <v-card>
      <a-table :columns="headers" :data-source="list" :pagination="false" bordered :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }">
        <template slot="fincome" slot-scope="text, record">
          <span class="text-h6 success--text">
            {{ record.fincome }}
          </span>
        </template>
        <template slot="fcost" slot-scope="text, record">
          <span class="text-h6 error--text">
            {{ record.fcost }}
          </span>
        </template>
        <template slot="fprofit" slot-scope="text, record">
          <span :class="{ 'text-h6': true, 'success--text': record.profit > 0, 'error--text': record.profit < 0 }">
            {{ record.fprofit }}
          </span>
        </template>
        <template slot="fincome2" slot-scope="text, record">
          <span class="text-h6">
            {{ record.fincome2 }}
          </span>
        </template>
        <template slot="fcost2" slot-scope="text, record">
          <span class="text-h6">
            {{ record.fcost2 }}
          </span>
        </template>
        <template slot="fprofit2" slot-scope="text, record">
          <span :class="{ 'text-h6': true, 'success--text': record.profit2 > 0, 'error--text': record.profit2 < 0 }">
            {{ record.fprofit2 }}
          </span>
        </template>
      </a-table>
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";

export default {
  name: "FinanceManageDaily",
  data() {
    return {
      queryForm: {
        month: this.$moment().format("YYYY-MM"),
      },
      tab: 0,
      tablist: [],
      list: [],
      height: 600,
      month_menu: false,
      vrules: {
        required: (value) => !!value || "不能为空"
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    headers() {
      if (this.tab === 0 || this.tab === 1) {
        return [
          { title: "合同收入", dataIndex: "fincome", scopedSlots: { customRender: "fincome" }, width: 150, align: "center" },
          { title: "运费支出", dataIndex: "fcost", scopedSlots: { customRender: "fcost" }, width: 150, align: "center" },
          { title: "公司利润", dataIndex: "fprofit", scopedSlots: { customRender: "fprofit" }, width: 150, align: "center" },
          { title: "外包收入", dataIndex: "fincome2", scopedSlots: { customRender: "fincome2" }, width: 150, align: "center" },
          { title: "外包运费", dataIndex: "fcost2", scopedSlots: { customRender: "fcost2" }, width: 150, align: "center" },
          { title: "外包利润", dataIndex: "fprofit2", scopedSlots: { customRender: "fprofit2" }, width: 150, align: "center" },
          { title: "发车数", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 100, align: "center" },
        ];
      }
      return [
        { title: "线路", dataIndex: "postline_by", scopedSlots: { customRender: "postline_by" }, width: 150, align: "center" },
        { title: "收入", dataIndex: "fincome", scopedSlots: { customRender: "fincome" }, width: 150, align: "center" },
        { title: "支出", dataIndex: "fcost", scopedSlots: { customRender: "fcost" }, width: 150, align: "center" },
        { title: "利润", dataIndex: "fprofit", scopedSlots: { customRender: "fprofit" }, width: 150, align: "center" },
        { title: "发车数", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 100, align: "center" },
      ];
    },
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
    page() {
      this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 300;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 300;
    };
    this.tab = 0;
    this.list = []
    this.queryForm = {
      month: this.$moment().format("YYYY-MM"),
    };
    this.getdata();
  },
  activated() {
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dailyreport2/list", { ...this.queryForm, tab: this.tab }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list.map(n => {
            return {
              ...n,
              fincome: this.$utils.formatMoney(n.income, 2, ''),
              fcost: this.$utils.formatMoney(n.cost, 2, ''),
              fprofit: this.$utils.formatMoney(n.profit, 2, ''),
              fincome2: n.income2 ? this.$utils.formatMoney(n.income2, 2, '') : '',
              fcost2: n.cost2 ? this.$utils.formatMoney(n.cost2, 2, '') : '',
              fprofit2: n.profit2 ? this.$utils.formatMoney(n.profit2, 2, '') : '',
            }
          });
          this.tablist = res.data.tablist;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    changetab(tab) {
      console.log('changetab', tab);
      this.list = [];
      this.getdata();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}
</style>
